(function ($, Drupal, drupalSettings) {

  'use strict';

  const container = document.querySelector('.js-oppurtunities-container');
  const root = document.querySelector(':root');

  // Exit on pages where the container does not exist.
  if (!container) return;

  Drupal.behaviors.promutuel_careerSticky = {
    attach: function attach(context) {

      // Fake sticky position.
      containerHeight();
      window.addEventListener('resize', event => {
        containerHeight();
      });

    }
  }

  function containerHeight() {
    const parent = container.parentElement;
    if (Promutuel.responsive?.getCurrentSize() > Promutuel.responsive?.BREAKPOINTS.MD) {
      const height = (container.offsetHeight + 50) + 'px';
      root.style.setProperty('--oppurtunities-fake-bg-height', height);
    }
  }

})(jQuery, Drupal, drupalSettings);
